import React from 'react';
import { ButtonRectangleRadioGroup } from '@yme/atoms/button-select';
import { SIZE_KEY } from '@yme/selectors/constants';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { FlexWrapperStyled } from './styled';
export function SelectSize({ productFilterOptions, allOptions, possibleOptions, allProductSizeValues, productVariantsByColor, isSquareButton, onSelectNewValue, allowClickOnDisabled, children, isRadioVisible, }) {
    const { size = '', colorItemIndex = 0 } = productFilterOptions;
    const isCurrentFilterExist = Boolean(allProductSizeValues && allProductSizeValues?.length);
    if (!isCurrentFilterExist && Boolean(size)) {
        return null;
    }
    const productVariantsByIndex = productVariantsByColor[colorItemIndex];
    const currentColorId = (productVariantsByColor && productVariantsByIndex?.colourId) || `color_index_${colorItemIndex}`;
    const selectableOptions = allowClickOnDisabled
        ? possibleOptions.map((option) => {
            return {
                ...option,
                isDisabled: !Boolean(productVariantsByIndex.variantsOfProduct.find((v) => v.size === option.value && v.stock > 0)),
            };
        })
        : possibleOptions;
    return (React.createElement(FlexWrapper, { mt: "20px", flexDirection: "column" },
        React.createElement(FlexWrapper, { mb: "8px", justifyContent: "space-between" }, children),
        React.createElement(FlexWrapperStyled, { flexDirection: "row", flexWrap: isSquareButton ? 'wrap' : undefined, gap: "12px", isSquareButton: isSquareButton },
            React.createElement(ButtonRectangleRadioGroup, { contentTag: RegularTextLevel4, setActiveOption: onSelectNewValue, allOptions: allOptions, possibleOptions: selectableOptions, selectedValue: size, keyOfColorGroup: currentColorId, dataTestId: SIZE_KEY, allowClickOnDisabled: allowClickOnDisabled, isRadioVisible: isRadioVisible }))));
}
SelectSize.displayName = 'SelectSize_Component';
